module.exports = __webpack_public_path__ + "static/media/27a.cd906b48.jpg";